module.exports = __webpack_public_path__ + "images/forest/impact-02.325faece96f289d35293b421d0484ea5.jpg";